// src/redux/actions/cityActions.js
import {
    FETCH_GETORGSTYPES_REQUEST,
    FETCH_GETORGSTYPES_SUCCESS,
    FETCH_GETORGSTYPES_FAILURE,
    SET_SELECTED_GETORGSTYPES,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchOrganizationData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_GETORGSTYPES_REQUEST });
  
    try {
      const response = await axios.get(`/MasterDDL/GetOrgTypesDDL`);
      let orgstypesList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_GETORGSTYPES_SUCCESS,
        payload: orgstypesList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETORGSTYPES_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectOrgsTypes = (orgstypesId) => ({
    type: SET_SELECTED_GETORGSTYPES,
    payload: orgstypesId,
  });
  